import { LocalStorage } from '../../shared/utils';
import showKeepMediaConsistentDialog from '../../components/KeepMediaConsistentDialog/showKeepMediaConsistentDialog';
import {
  CONSISTENCY_ACTIONS,
  LISTING_MASTER_CONSISTENCY_DONT_SHOW_KEY,
} from './consistencyActions';
import {
  applyMasterMirrorToTargets,
  computeDesiredMasterMirror,
  shouldShowListingMasterConsistency,
} from './listingMasterConsistency';

export { CONSISTENCY_ACTIONS, LISTING_MASTER_CONSISTENCY_DONT_SHOW_KEY };

/**
 * Optionally prompts to also attach listing media to related Master layers.
 * @returns {Promise<{ action: string, targets: object }>}
 */
export default async function confirmListingMasterConsistencyIfNeeded({
  targets,
  assets = [],
  masterProductId,
  productsState,
  salesChannels = [],
} = {}) {
  const dontShowAgain = Boolean(
    LocalStorage.get(LISTING_MASTER_CONSISTENCY_DONT_SHOW_KEY),
  );

  const shouldShow = shouldShowListingMasterConsistency({
    targets,
    assets,
    masterProductId,
    productsState,
    salesChannels,
    dontShowAgain,
  });

  if (!shouldShow) {
    return {
      action: CONSISTENCY_ACTIONS.LISTING_ONLY,
      targets,
    };
  }

  const { action, dontShowAgain: checkedDontShow } = (
    await showKeepMediaConsistentDialog()
  );

  if (action === CONSISTENCY_ACTIONS.CANCEL) {
    return {
      action: CONSISTENCY_ACTIONS.CANCEL,
      targets,
    };
  }

  if (checkedDontShow) {
    LocalStorage.set(LISTING_MASTER_CONSISTENCY_DONT_SHOW_KEY, true);
  }

  if (action === CONSISTENCY_ACTIONS.LISTING_AND_MASTER) {
    const desired = computeDesiredMasterMirror({
      targets,
      productsState,
      salesChannels,
    });
    return {
      action: CONSISTENCY_ACTIONS.LISTING_AND_MASTER,
      targets: applyMasterMirrorToTargets(targets, desired),
    };
  }

  return {
    action: CONSISTENCY_ACTIONS.LISTING_ONLY,
    targets,
  };
}
